import { useEffect, useState } from "react";
import { getSettings } from "../lib/api";

const DEFAULTS = {
  contact: {
    address: "Via Giosuè Carducci 12, 20123 Milano (MI)",
    email: "amministrazione@vecchiocinghiale.beer",
    phone: "+39 011 555 0142",
  },
  socials: [
    { label: "Instagram", url: "#" },
    { label: "Facebook", url: "#" },
  ],
  footer_text: "Birrificio tradizionale indipendente. Qualità senza compromessi dal 2025.",
  p_iva: "14319730967",
};

const LEGAL_LINKS = [
  { to: "/condizioni-acquisto", label: "Condizioni di acquisto", testid: "footer-acquisto" },
  { to: "/condizioni-consegna", label: "Condizioni di consegna", testid: "footer-consegna" },
  { to: "/politica-rimborso", label: "Politica di rimborso", testid: "footer-rimborso" },
  { to: "/condizioni-legali", label: "Condizioni legali", testid: "footer-legali" },
  { to: "/privacy", label: "Privacy Policy", testid: "footer-privacy" },
  { to: "/cookie-policy", label: "Cookie Policy", testid: "footer-cookie" },
  { to: "/gdpr", label: "Diritti GDPR", testid: "footer-gdpr" },
];

export const Footer = () => {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    getSettings()
      .then((s) =>
        setSettings({
          contact: s.contact || DEFAULTS.contact,
          socials: s.socials || DEFAULTS.socials,
          footer_text: s.footer_text || DEFAULTS.footer_text,
          p_iva: s.p_iva || DEFAULTS.p_iva,
        })
      )
      .catch(() => {});
  }, []);

  const { contact, socials, footer_text, p_iva } = settings;

  return (
    <footer className="bg-[#141A14] border-t border-white/10 py-16" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <img
              src="/logo-white.png"
              alt="Birrificio Vecchio Cinghiale"
              className="h-14 w-auto object-contain mb-6"
            />
            <p className="text-sm text-[#E8E2D2]/50 max-w-xs leading-relaxed" data-testid="footer-text">
              {footer_text}
            </p>
          </div>
          <div>
            <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#D47738] mb-4">
              Contatti
            </p>
            <ul className="space-y-2 text-sm text-[#E8E2D2]/50" data-testid="footer-contact">
              {contact.address && <li>{contact.address}</li>}
              {contact.email && <li>{contact.email}</li>}
              {contact.phone && <li>{contact.phone}</li>}
            </ul>
          </div>
          <div>
            <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#D47738] mb-4">
              Seguici
            </p>
            <ul className="space-y-2 text-sm text-[#E8E2D2]/50" data-testid="footer-socials">
              {(socials || []).filter((s) => s.label).map((s, i) => (
                <li key={i}>
                  <a href={s.url || "#"} target="_blank" rel="noreferrer" className="hover:text-[#D47738] transition-colors">
                    {s.label}
                  </a>
                </li>
              ))}
              <li><a href="/admin" className="hover:text-[#D47738] transition-colors">Area Riservata</a></li>
            </ul>
          </div>
          <div>
            <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#D47738] mb-4">
              Legale
            </p>
            <ul className="space-y-2 text-sm text-[#E8E2D2]/50">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <a href={l.to} className="hover:text-[#D47738] transition-colors" data-testid={l.testid}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between gap-4">
          <p className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/30" data-testid="footer-copyright">
            © 2026 Birrificio Vecchio Cinghiale S.r.l. — Tutti i diritti riservati · Bevi responsabilmente (18+)
          </p>
          <p className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/30" data-testid="footer-piva">
            P.IVA {p_iva}
          </p>
        </div>
      </div>
    </footer>
  );
};
